module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/4/2-2e4c85f08b9dd42add4b6788e782c5f6.jpg";